import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

interface BrandTheme {
  headerColor: string;
  textColor: string;
}

const brandThemes: Record<string, BrandTheme> = {
  elvang: {
    headerColor: '#ddc097',
    textColor: '#706c6c'
  },
  gefu: {
    headerColor: '#2a2929',
    textColor: '#f2efef'
  },
  myflame: {
    headerColor: '#814758',
    textColor: '#605457'
  },
  remember: {
    headerColor: '#F4D03F',
    textColor: '#8B6914'
  },
  rader: {
    headerColor: '#E8D2AE',
    textColor: '#8B7355'
  },
  ppd: {
    headerColor: '#48CAE4',
    textColor: '#1B4C5C'
  },
  relaxound: {
    headerColor: '#52B788',
    textColor: '#1D4332'
  }
};

const Header: React.FC = () => {
  const [showBrandsMenu, setShowBrandsMenu] = useState(false);
  const [currentTheme, setCurrentTheme] = useState<BrandTheme | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const brands = [
    { name: 'Elvang', path: '/brand/elvang' },
    { name: 'Gefu', path: '/brand/gefu' },
    { name: 'Remember', path: '/brand/remember' },
    { name: 'Rader', path: '/brand/rader' },
    { name: 'PPD', path: '/brand/ppd' },
    { name: 'Relaxound', path: '/brand/relaxound' },
    { name: 'My Flame Lifestyle', path: '/brand/myflame' }
  ];

  useEffect(() => {
    const brandMatch = location.pathname.match(/\/brand\/(.+)/);
    if (brandMatch) {
      const brandId = brandMatch[1];
      const theme = brandThemes[brandId];
      if (theme) {
        setCurrentTheme(theme);
      }
    } else {
      setCurrentTheme(null);
    }
  }, [location.pathname]);

  const handleNavigation = (path: string) => {
    navigate(path);
    setShowBrandsMenu(false);
  };

  const headerStyle = currentTheme ? {
    backgroundColor: currentTheme.headerColor,
    color: currentTheme.textColor
  } : {};

  return (
    <header className="main-header">
      <div className="header-background" style={headerStyle}>
        <div className="header-content" style={currentTheme ? { color: currentTheme.textColor } : {}}>
          <div className="logo-container">
            <div className="dmb-logo" onClick={() => handleNavigation('/')}>
              <img src="/logos/dmb-logo.png" alt="DMB" />
            </div>
          </div>
          
          <nav className="main-nav" style={currentTheme ? { color: 'white' } : {}}>
            <div 
              className="nav-item brands-dropdown"
              onMouseEnter={() => setShowBrandsMenu(true)}
              onMouseLeave={() => setShowBrandsMenu(false)}
              style={currentTheme ? { color: 'white' } : {}}
            >
              <span>brands</span>
              <div className={`dropdown-menu ${showBrandsMenu ? 'show' : ''}`}>
                {brands.map((brand) => (
                  <div 
                    key={brand.name}
                    className="dropdown-item"
                    onClick={() => handleNavigation(brand.path)}
                  >
                    {brand.name}
                  </div>
                ))}
              </div>
            </div>
            
            <div className="nav-item" onClick={() => handleNavigation('/about')} style={currentTheme ? { color: 'white' } : {}}>
              about
            </div>
            
            <div className="nav-item" onClick={() => handleNavigation('/contact')} style={currentTheme ? { color: 'white' } : {}}>
              contact
            </div>
            
            <div className="nav-item" onClick={() => handleNavigation('/events')} style={currentTheme ? { color: 'white' } : {}}>
              events
            </div>
            
            <button 
              className="customer-login-btn"
              onClick={() => handleNavigation('/customer/auth')}
            >
              customer login
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;